import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, DumbbellIcon, HeartPulseIcon, UsersIcon } from 'lucide-react';
export function WhoIHelp() {
  const audiences = [{
    title: 'Athletes',
    description: 'Return to your sport with confidence. We focus on performance, capacity, and preparing you for the demands of your sport.',
    icon: <ActivityIcon size={32} className="text-amber-500" data-id="element-297" data-mp="1px8ml4nad32n" />
  }, {
    title: 'Lifters',
    description: 'Work through pain and keep progressing. We build strength, tolerance, and confidence under the bar.',
    icon: <DumbbellIcon size={32} className="text-amber-500" data-id="element-298" data-mp="1h3vntm2jj78n" />
  }, {
    title: 'Post-Surgery',
    description: "Whether it's ACL reconstruction, joint replacement, rotator cuff repair, or spinal surgery—we bridge the gap between rehab and real life, restoring your confidence and preparing you for the activities that matter most.",
    icon: <HeartPulseIcon size={32} className="text-amber-500" data-id="element-299" data-mp="12jiactoadud4" />
  }, {
    title: 'Active Adults',
    description: 'Stay active, keep up with your life, and continue doing what you enjoy—without feeling limited by pain or stiffness.',
    icon: <UsersIcon size={32} className="text-amber-500" data-id="element-300" data-mp="tqog9q46kqf7" />
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="who-i-help" className="py-24 bg-offwhite-50" data-id="element-301" data-mp="eto08jvcqjwk">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-302" data-mp="etxqm8kb6t2s">
        <div className="text-center mb-16" data-id="element-303" data-mp="255k2bx55pu5s">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-charcoal-950 mb-4" data-id="element-304" data-mp="256v7a0ac97yh">
            Who I Help
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-charcoal-800 max-w-2xl mx-auto" data-id="element-305" data-mp="394h1ev45qyki">
            Specialized care for people who want to stay active and keep doing
            what matters—without being held back by pain.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-306" data-mp="oeroinn0lmug">
          {audiences.map((audience, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm border border-offwhite-200 hover:shadow-md transition-shadow" data-id="element-307" data-mp="vz2d8xjkku71" data-mpi={index}>
              <div className="bg-offwhite-100 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-308" data-mp="19xa20i6gcp74">
                {audience.icon}
              </div>
              <h3 className="text-xl font-bold text-charcoal-950 mb-3" data-id="element-309" data-mp="1eu901bt8lgal">
                {audience.title}
              </h3>
              <p className="text-charcoal-800 leading-relaxed" data-id="element-310" data-mp="1olwu7kh6hbfr">
                {audience.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}